
import { Link } from 'react-router-dom';

const clients = [
  {
    name: 'HMS Group',
    location: 'Germany',
    detail: 'German-based company listed on the German stock exchange',
    icon: 'ri-stock-line',
  },
  {
    name: 'Tipuwell',
    location: 'International',
    detail: 'Established chrome trading partner with proven track record',
    icon: 'ri-shake-hands-line',
  },
  {
    name: 'Tobun & Tobun',
    location: 'International',
    detail: 'Long-standing client relationship in chrome commodity trading',
    icon: 'ri-handshake-line',
  },
  {
    name: 'EMWS',
    location: 'International',
    detail: 'Key partner in the global chrome supply chain network',
    icon: 'ri-global-line',
  },
];

export default function ClientPortfolio() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-[#8B1538] font-bold text-sm uppercase tracking-wider">
            Trusted Partners
          </span>
          <h2 className="text-4xl md:text-5xl font-bold mt-3 mb-6 text-gray-900 font-['Montserrat']">
            International Client Portfolio
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            TMI has supplied chrome products to leading international companies and continues to attract new
            global clients
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {clients.map((client, index) => (
            <div
              key={index}
              className="group bg-gray-50 rounded-lg p-8 text-center hover:bg-[#8B1538] transition-all duration-300 cursor-default"
            >
              <div className="w-16 h-16 mx-auto bg-white rounded-full flex items-center justify-center mb-5 shadow-sm group-hover:bg-white/20 transition-colors">
                <i
                  className={`${client.icon} text-3xl text-[#8B1538] group-hover:text-white transition-colors`}
                ></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 group-hover:text-white font-['Montserrat'] mb-1 transition-colors">
                {client.name}
              </h3>
              <span className="text-sm text-[#8B1538] group-hover:text-white/80 font-medium transition-colors">
                {client.location}
              </span>
              <p className="text-sm text-gray-600 group-hover:text-white/80 mt-3 leading-relaxed transition-colors">
                {client.detail}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-gray-50 to-red-50 rounded-lg p-10 flex flex-col lg:flex-row items-center gap-8">
          <div className="flex-1">
            <h3 className="text-2xl font-bold text-gray-900 font-['Montserrat'] mb-3">
              Growing International Presence
            </h3>
            <p className="text-gray-700 text-[15px] leading-relaxed">
              TMI is currently in the process of attracting more international clients, who are keen and have proven
              records of prepaying for chrome products with a number of local and other international suppliers.
              Our commitment to quality and competitive pricing continues to open doors in global markets.
            </p>
          </div>
          <Link
            to="/contact"
            className="bg-[#8B1538] text-white px-8 py-4 rounded-lg font-medium hover:bg-[#6B0F2A] transition-colors whitespace-nowrap flex items-center gap-2 cursor-pointer"
          >
            <span>Become a Partner</span>
            <i className="ri-arrow-right-line text-lg"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
